module.exports = __webpack_public_path__ + "static/media/saas-sketch-4.68815eac.svg";